// Top-level config (shared)
window.INVENTORY_API_CONFIG = window.INVENTORY_API_CONFIG || {
  'la-apparel-dev.myshopify.com': { apiBase: 'https://laapparel.co/main/laa/shopify/inventory/', env: 'dev' },
  'losangelesapparel.net': { apiBase: 'https://laapparel.co/main/laa/shopify/inventory/', env: 'prod' },
};

window.getAimsConfig = window.getAimsConfig || function getAimsConfig() {
  return window.INVENTORY_API_CONFIG[window.location.hostname] || window.INVENTORY_API_CONFIG['losangelesapparel.net'];
};

class PickupInventoryTable extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.onAddToCart = this.onAddToCart.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.variantId = this.dataset.variantId;
    this.listEl = this.querySelector('[data-store-availability-drawer-content]');
    if (!this.variantId || !this.listEl) return;

    this.attachAddToCartHandlers();
    this.fetchInventoryCount();
  }

  disconnectedCallback() {
    this.listEl.removeEventListener('click', this.onAddToCart);
  }

  async fetchInventoryCount() {
    const { apiBase, env } = window.getAimsConfig();
    const url = `${apiBase}${this.variantId}?env=${env}`;

    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.statusText);
      const data = await res.json();

      (data.inventory || []).forEach((loc) => {
        const locId = loc.location_id.split('/').pop();
        const li = this.listEl.querySelector(`li[data-location-id="${locId}"]`);

        if (!li || !loc.pickup_available) {
          li?.classList.add('hidden');
          return;
        }

        // Update drawer badge
        const span = li.querySelector('.inventory-count');
        if (span) {
          const qty = loc.quantities?.available ?? 0;
          let text = `${qty} Available`;
          let cls = '';
          if (qty > 10)       { text = '10+ Available'; cls = 'avail'; }
          else if (qty === 0) { text = '0 Available';   cls = 'no-qty'; }
          else if (qty < 5)   { text = 'Almost gone!';  cls = 'limited'; }

          span.textContent = text;
          if (cls) span.classList.add(cls);
        }

        // Update preview stock line for this location (first/closest)
        const preview = document.querySelector(`pickup-availability-preview[data-location-id="${locId}"]`);
        if (preview) {
          const stockEl = preview.querySelector('[data-preview-stock]');
          if (stockEl) {
            const qty = loc.quantities?.available ?? 0;
            stockEl.textContent = qty > 10 ? '+10 in stock' : qty === 0 ? 'Out of stock' : `${qty} in stock`;
            stockEl.classList.toggle('out-of-stock', qty === 0);
          }
        }
      });
    } catch (err) {
      console.error('Error loading inventory:', err);
    }
  }

  attachAddToCartHandlers() {
    this.listEl.addEventListener('click', this.onAddToCart);
  }

  async onAddToCart(event) {
    const btn = event.target.closest('.pickup-add-to-cart-btn');
    if (!btn) return;

    btn.classList.add('loading');
    const variantId = btn.dataset.variantId;
    const location = btn.dataset.locationName;

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          sections: sectionIds.join(','),
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Add to cart failed');

      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartRes.json();

      const cartEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: variantId,
          data: {
            source: 'pickup-inventory-table',
            itemCount: cart.item_count,
            variantId,
            sections: data.sections,
          },
        },
      });
      document.dispatchEvent(cartEvent);

      // Trigger the checkmark-burst animation on the pickup button
      btn.dataset.added = 'true';
      setTimeout(() => btn.removeAttribute('data-added'), 1600);
    } catch (e) {
      console.error(e);
      alert('Sorry, could not add to cart.');
    } finally {
      btn.classList.remove('loading');
    }
  }
}

if (!customElements.get('pickup-inventory-table')) {
  customElements.define('pickup-inventory-table', PickupInventoryTable);
}
